import { render, staticRenderFns } from "./EntityDateField.vue?vue&type=template&id=796cb62c&scoped=true&lang=pug&"
import script from "./EntityDateField.vue?vue&type=script&lang=js&"
export * from "./EntityDateField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796cb62c",
  null
  
)

export default component.exports